import React from 'react';
import PropTypes from 'prop-types';

function CompareProductPriceBlock(props) {

  const outOfStockClass = props.isOutOfStock ? 'dc-product-price-block__out-of-stock' : '';

  function getWasPriceBlockForRegularProduct() {
    return (
      <div className="dc-product-price-block__was-price">
        <span>
          {props.translations.wasPriceTranslation} {props.wasPrice}
        </span>

        {props.wasPriceFrom && props.wasPriceTo &&
        <span>
          {
            ` (${props.translations.fromDateTranslation} ${props.wasPriceFrom} ` +
            `${props.translations.toDateTranslation} ${props.wasPriceTo})`
          }
        </span>
        }
      </div>
    );
  }

  function getWasPriceBlockForBundleProduct() {
    return (
      <div className="dc-product-price-block__was-price">
        {
          `${props.translations.mainProductWasPriceTranslation} ${props.mainProductWasPrice}, ` +
          `${props.translations.mainProductCurrentPriceTranslation} ` +
          `${props.mainProductCurrentPrice}`
        }
      </div>
    );
  }

  return (
    <div
      data-component="CompareProductPriceBlock"
      className={`dc-product-price-block ${outOfStockClass}`}
    >
      <div className="dc-product-price-block__current-price">
        {props.price}
      </div>
      {props.savingsPrice &&
      <div className="dc-product-price-block__save-price">
        {props.translations.savingsPriceTranslation} {props.savingsPrice}
      </div>
      }
      {!props.isComboKit && props.wasPrice &&
        getWasPriceBlockForRegularProduct()
      }
      {props.isComboKit && props.mainProductWasPrice && props.mainProductCurrentPrice &&
        getWasPriceBlockForBundleProduct()
      }
    </div>
  );
}

CompareProductPriceBlock.propTypes = {
  price: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    savingsPriceTranslation: PropTypes.string.isRequired,
    wasPriceTranslation: PropTypes.string.isRequired,
    mainProductWasPriceTranslation: PropTypes.string.isRequired,
    mainProductCurrentPriceTranslation: PropTypes.string.isRequired,
    fromDateTranslation: PropTypes.string.isRequired,
    toDateTranslation: PropTypes.string.isRequired
  }).isRequired,
  isComboKit: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  savingsPrice: PropTypes.string,
  wasPrice: PropTypes.string,
  mainProductCurrentPrice: PropTypes.string,
  mainProductWasPrice: PropTypes.string,
  wasPriceFrom: PropTypes.string,
  wasPriceTo: PropTypes.string
};

CompareProductPriceBlock.defaultProps = {
  isComboKit: false,
  isOutOfStock: false,
  savingsPrice: undefined,
  mainProductCurrentPrice: undefined,
  mainProductWasPrice: undefined,
  wasPrice: undefined,
  wasPriceFrom: undefined,
  wasPriceTo: undefined

};

export default CompareProductPriceBlock;
